import { useSelector } from 'react-redux'
import { matchRoutes, useLocation } from 'react-router-dom'

import {
  getAccountId,
  isAccountTypeBrand,
  isLiteRetailer as isLiteRetailerSelector,
} from 'store/currentUser/selectors'

import {
  PASSPORT_PATHS,
  PUBLIC_PRODUCT_CATALOG,
  PUBLIC_RETAILER_PROFILE,
  SHOPIFY_INTEGRATION,
  SHOWROOM_PUBLIC_COLLECTION_VIEW,
  STOREFRONT_PATHS,
} from 'routes/paths'

import { NavbarLiteRetailer } from '../features/Navbar/NavbarLiteRetailer/NavbarLiteRetailer'
import PublicNavbar from 'features/Navbar/NavbarPublic/PublicNavbar'
import NavbarRevamp from 'features/Navbar/NavbarRevamp/NavbarRevamp.component'
import { PRODUCTS_PAGE_CONTENT_PARAM } from 'features/Orders/Review/modals/ProductsEditModal/productsEditModal.constants'
import EditionNavbar from 'features/Storefront/EditionNavbar'

const PageNavbar = () => {
  const location = useLocation()
  const pathname = location.pathname

  const accountId = useSelector(getAccountId)
  const isBrandAccount = useSelector(isAccountTypeBrand)
  const isLiteRetailer = useSelector(isLiteRetailerSelector)

  const isPassport = matchPaths(pathname, PASSPORT_PATHS)
  const isStorefront = matchPaths(pathname, STOREFRONT_PATHS)
  const isPublicShowroom = matchPaths(pathname, [
    SHOWROOM_PUBLIC_COLLECTION_VIEW,
  ])
  const isPublicCatalog = matchPaths(pathname, [PUBLIC_PRODUCT_CATALOG])
  const isPublicRetailerProfile = matchPaths(pathname, [
    PUBLIC_RETAILER_PROFILE,
  ])

  const NAVBAR_HIDDEN_ROUTES = [SHOPIFY_INTEGRATION]
  const NAVBAR_HIDDEN_PARAMS = [PRODUCTS_PAGE_CONTENT_PARAM]

  if (shouldHideNavbar(NAVBAR_HIDDEN_ROUTES, NAVBAR_HIDDEN_PARAMS)) return null

  const isOwner = isStorefrontOwner({
    pathname,
    isStorefront,
    isBrandAccount,
    accountId,
  })

  //lite brands get the (restricted) edition navbar on their own storefront
  if (isStorefront && isOwner) {
    return <EditionNavbar />
  }

  if (isLiteRetailer) {
    return <NavbarLiteRetailer />
  }

  if (
    isPublicShowroom ||
    isPublicCatalog ||
    isPassport ||
    isPublicRetailerProfile
  ) {
    return <PublicNavbar />
  }

  return <NavbarRevamp />
}

// Utils for getting the conditions to get the navbar to show

const matchPaths = (pathname: string, patterns: string[]) => {
  return (
    matchRoutes(
      patterns.map((path) => ({ path })),
      pathname,
    ) !== null
  )
}

export const shouldHideNavbar = (routes: string[], params: string[]) => {
  const currentPath = window.location.pathname
  const searchParams = new URLSearchParams(window.location.search)

  const isMatchingRoute = matchPaths(currentPath, routes)
  const hasMatchingParam = params.some((param) => searchParams.has(param))

  return isMatchingRoute || hasMatchingParam
}

const isStorefrontOwner = ({
  pathname,
  isStorefront,
  isBrandAccount,
  accountId,
}: {
  pathname: string
  isStorefront: boolean
  isBrandAccount: boolean
  accountId: number
}) => {
  const storefrontPathParams = pathname?.split('/')
  const storefrontId =
    storefrontPathParams.length > 4
      ? storefrontPathParams?.[storefrontPathParams?.length - 2]
      : storefrontPathParams?.[storefrontPathParams?.length - 1]

  return (
    isStorefront && isBrandAccount && accountId === parseInt(storefrontId, 10)
  )
}

export default PageNavbar
